import {checkIfUnitTypeChangeExceedsLimit} from './checkIfUnitTypeChangeExceedsLimit';

/**
 * Превысит ли отмена улучшения отряда лимит отрядов одного типа. Отряд
 * возвращается к прежнему типу, а после улучшения мог появиться другой отряд
 * этого типа: лимит пропустил его найм как раз потому, что улучшенный отряд
 * из этого типа ушел. Кнопка отмены до такого не доходит — она снимает
 * действия с конца, а двойной клик по отряду может.
 */
export const checkIfUnitUpgradeUndoExceedsLimit = (upgradeAction, player, units) => {
  if (upgradeAction.actionType !== 'UNIT_UPGRADE') {
    return false;
  }

  return checkIfUnitTypeChangeExceedsLimit(upgradeAction.unitId, upgradeAction.prevType, player, units);
};
